

(function () {
    const BULK_EVENT_URL = 'https://a.klaviyo.com/client/event-bulk-create/?company_id=';

    /** Class for interacting with the klaviyo client api */
    class KlaviyoManager {
        /** 
         * Gets the exchange id from the cookie
         * @return {string} the value or null if it does not exist
         */
        getExchangeId = () => {
            const klaviyoIdCookie = $.cookie("__kla_id");
            let exchangeId = null;
            if (klaviyoIdCookie) {
                const decodedKlaviyoCookie = JSON.parse(atob(klaviyoIdCookie));
                if (decodedKlaviyoCookie && decodedKlaviyoCookie["$exchange_id"]) {
                    exchangeId = decodedKlaviyoCookie["$exchange_id"];
                }
            }

            return exchangeId;
        };

        /**
         * Tracks events using the klaviyo bulk create event API 
         * @param {any} eventData an array of event data objects
         * @param {any} apiKey the Klaviyo public api key for the current environment
         * @returns
         */
        trackEvents = (eventData, apiKey) => {
            let exchangeId = this.getExchangeId();
            if (!exchangeId) {
                return;
            }

            const requestOptions = {
                url: BULK_EVENT_URL + apiKey,
                method: "POST",
                headers: {
                    accept: "application/json",
                    revision: "2025-01-15",
                    'content-type': "application/json"
                },
                data: JSON.stringify({
                    "data": {
                        "type": "event-bulk-create",
                        "attributes": {
                            "profile": {
                                "data": {
                                    "type": "profile",
                                    "attributes": {
                                        "_kx": exchangeId,
                                    }
                                }
                            },
                            "events": {
                                "data": eventData
                            }
                        }
                    }
                }),
            };

            $.ajax(requestOptions);
        };
    }

    window.klaviyoManager = new KlaviyoManager();

})();
